
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"pause-circle","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M1.705 10a8.32 8.32 0 108.32-8.32A8.32 8.32 0 001.705 10z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.056 12.124V7.875c0-.403.168-.563.6-.563h1.088c.428 0 .6.16.6.563v4.25c0 .4-.168.563-.6.563h-1.088c-.432-.001-.6-.161-.6-.564zM6.66 12.124V7.875c0-.403.168-.563.6-.563h1.08c.428 0 .6.16.6.563v4.25c0 .4-.168.563-.6.563H7.26c-.432-.001-.6-.161-.6-.564z"}})])])
          )
        }
      }
    